import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1 } from './formField';
import { FormField, RadioGroup } from 'components';
import { omit } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Cancel } from 'assets/icons/cancel_icon.svg';
import { isAuditor, isBeneficiary, isInvestor } from 'utils';

const TermsBeneficiary = () => {
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const taskName = useSelector(state => state.forms.task.name);
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const terms = useSelector(state => state.forms.terms);

  const dispatch = useDispatch();

  useEffect(() => {
    form.setFieldsValue({
      terms1: terms.terms1,
      terms2: terms.terms2,
      terms3: terms.terms3,
      terms4: terms.terms4,
      terms5: terms.terms5,
      terms6: terms.terms6,
      terms7: terms.terms7,
    });
  }, [form, terms]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    dispatch(
      updateFormField({
        group: 'terms',
        key,
        value: newValue,
      })
    );
  };

  return (
    <div>
      {/* {!viewMode && requiredFieldsError && (
        <div className="stepper-warning-message error-message">
          <div>
            Για την ενεργοποίηση της υποβολής απαιτείται η συμπλήρωση των
            υποχρεωτικών πεδίων και των δικαιολογητικών.
          </div>
          <Cancel
            className="cancel-icon"
            onClick={() => setRequiredFieldsError(false)}
          />
        </div>
      )} */}
      <Form
        form={form}
        initialValues={
          {
            // ...carrier,
          }
        }
        trigger="onChange"
      >
        <p className="mt-0 mr-0 color-blue-3 text-bold font-size-19">
          Όροι και Προϋποθέσεις
        </p>
        <Row style={{ width: '90%' }}>
          {formFields.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  valuePropName="checked"
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
          <Col
            key={1}
            className="gutter-row"
            span={'24'}
            style={{ marginTop: '1rem' }}
          >
            <Form.Item
              className="requirementsRadio"
              name={'terms22'}
              id={'terms22'}
              rules={[
                { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
              ]}
            ></Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TermsBeneficiary;
